import flatpickr from 'flatpickr';
import React, { useEffect, useState } from 'react';
import { formatDateTime, startLoader, stopLoader } from '../../../lib/utils';
import { getUsersList,getUsersListV2 } from '../../employees/helper/api';
import { isAuthenticated } from '../../../auth';
import Toast from '../../../lib/toast';
import { editMembershipDate } from '../../memberships/helper/api';


const EditMembershipModal = (props) => {
  
  const membership = props.membership;
  const [currentElementId, setCurrentElementId] = useState("");
  // const [startDate, setStartDate] = useState("");
  // const [endDate, setEndDate] = useState(new Date());
  const [selectedTrainer, setSelectedTrainer] = useState("");
  const [isTrainerListOpen, setTrainerListOpen] = useState(false);
  const [trainers,setTrainers] = useState([])
  const {user,token} = isAuthenticated();
  const [isButtonLock,setButtonLock] = useState(false);
  


  const EditMemberShip = async event =>{
    try{

      await startLoader()
      setButtonLock(true)
      const payload = {
        // newStartDate:startDate,
        trainer_id:selectedTrainer._id
      }

      const response = await editMembershipDate(user._id,token,membership._id,payload);


      if(response.error){
        new Toast({
          type:"error",
          duration:3000,
          message:response.error
        })
      }else{
        new Toast({
          type:"success",
          duration:3000,
          message:"Membership updated successfully"
        })
        props.reload();
        props.toggleFitnessTestModal("edit-membership");
      }

    }catch(error){
      new Toast({
        type:"error",
        duration:3000,
        message:error
      })
    }

    setButtonLock(false)
    await stopLoader()
  }


    const GetUserParams = () =>{
      const branchId = membership.branchId;
      const params = {
        noLimit:'noLimit',
        branchIDs:[branchId],
        isAllUser:true,
        roles:[5,6,7,10,2]
      };
  
  
      return params;
    }
  
    const GetAllUser = async () =>{
      try{
        const params = GetUserParams();
        const response = await getUsersListV2(user._id,token,params);
        if(response.error){
        }else{
          setTrainers(response)
        }
      }catch(error){
  
      }
    }
  

  const toggleInputFields = (id) => event => {
    setCurrentElementId(id);

    // if(id == "start-date"){
    //   openDateAndTime();
    // }

    if(id == "select-trainer"){
      setTrainerListOpen(!isTrainerListOpen)
    }

  }

  // const openDateAndTime = () => {
  

  //   try{
  //      const startDatePicker = flatpickr("#start-date", {
  //       disableMobile: true,
  //       onChange: ([date]) => {  
  //         setStartDate(date);
  //       }
  //     });

  //   startDatePicker.open();
   
  //   }catch(error){

  //   }
  
  //   // return () => {
  //   //   startDatePicker.destroy();
  //   // }
  // }


  const handleSelectTrainer = (trainerInfo) => {
    setSelectedTrainer(trainerInfo)
  } 

  useEffect(()=>{
    if(membership){
      // setEndDate(new Date(membership.ends_at))
      // setStartDate(new Date(membership.starts_at))
      setSelectedTrainer(membership.trainer[0])
      GetAllUser();
    }
  },[props])

  if(!membership) return <></>;

  return (
    <div className={`${window.innerWidth > 767 ? "global-modal-container d-flex" : "w-full h-full"}`}>
      <div className={`${window.innerWidth > 767 ? "edit-membership-modal flex-item" : "w-full h-full"}`} style={window.innerWidth > 767 ? {} : {display:"flex", flexDirection:"column", height:"100%"}}>
        {
          window.innerWidth > 767 && (
            <div className="w-full d-flex space-between" style={{background: "var(--darkBlue)", padding:"12px", borderRadius: "16px 16px 0 0"}}>
              <div className='d-flex'>
                <svg className='flex-item' width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M25.4391 5.70878C25.0605 5.3107 24.6061 4.99239 24.1026 4.7726C23.5991 4.55282 23.0567 4.43601 22.5074 4.42904C21.9581 4.42208 21.4129 4.5251 20.904 4.73205C20.3951 4.939 19.9327 5.24568 19.5442 5.63404L6.56812 18.6094C6.11469 19.0629 5.79975 19.6361 5.66014 20.262L4.44627 25.729C4.42094 25.8426 4.42468 25.9607 4.45714 26.0725C4.4896 26.1843 4.54973 26.2861 4.63198 26.3685C4.71422 26.4508 4.81591 26.5111 4.92765 26.5438C5.03938 26.5764 5.15754 26.5804 5.2712 26.5552L10.7066 25.347C11.3541 25.2043 11.9469 24.8785 12.4146 24.4086L25.3671 11.4567C26.1263 10.6972 26.5588 9.67116 26.5722 8.59739C26.5857 7.52361 26.1791 6.48706 25.4391 5.70878ZM20.5227 6.61256C20.7759 6.35575 21.0774 6.15156 21.4098 6.01177C21.7423 5.87198 22.0991 5.79935 22.4597 5.79805C22.8203 5.79676 23.1777 5.86684 23.5111 6.00424C23.8445 6.14164 24.1475 6.34366 24.4025 6.59866C24.6575 6.85365 24.8595 7.15658 24.9969 7.48999C25.1343 7.8234 25.2044 8.18071 25.2031 8.54132C25.2018 8.90193 25.1292 9.25873 24.9894 9.59115C24.8496 9.92356 24.6454 10.225 24.3886 10.4782L23.4598 11.4069L19.594 7.54264L20.5227 6.61256ZM18.6154 8.52254L22.4813 12.3868L11.436 23.4315C11.1545 23.7154 10.7969 23.9119 10.4063 23.9975L6.03246 24.9691L7.01242 20.5637C7.09408 20.1942 7.27955 19.8565 7.54668 19.5893L18.6154 8.52254Z" fill="white"/>
                </svg>
                <p className="flex-item fs-18 font-weight-600 color-white m-l-5">Edit Membership</p>
              </div>
              <div onClick={()=>props.toggleFitnessTestModal("edit-membership")} className="d-flex desktop-modal-close-button" style={{width: "30px", height:"30px", background:"#f9f9f9"}}>
                <svg className="flex-item" width="20" height="20" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.9283 3.80866C4.77899 3.66445 4.57901 3.58465 4.37144 3.58646C4.16387 3.58826 3.96531 3.67152 3.81853 3.8183C3.67175 3.96508 3.58849 4.16364 3.58668 4.37121C3.58488 4.57879 3.66468 4.77876 3.80888 4.92807L8.38076 9.49995L3.80809 14.0718C3.73248 14.1449 3.67217 14.2322 3.63068 14.3288C3.58919 14.4254 3.56735 14.5293 3.56644 14.6344C3.56552 14.7395 3.58555 14.8437 3.62536 14.941C3.66516 15.0383 3.72395 15.1267 3.79828 15.2011C3.87261 15.2754 3.961 15.3342 4.0583 15.374C4.15559 15.4138 4.25983 15.4338 4.36495 15.4329C4.47007 15.432 4.57395 15.4101 4.67054 15.3687C4.76712 15.3272 4.85448 15.2669 4.92751 15.1912L9.50018 10.6194L14.0721 15.1912C14.2214 15.3354 14.4213 15.4152 14.6289 15.4134C14.8365 15.4116 15.035 15.3284 15.1818 15.1816C15.3286 15.0348 15.4119 14.8363 15.4137 14.6287C15.4155 14.4211 15.3357 14.2211 15.1915 14.0718L10.6196 9.49995L15.1915 4.92807C15.3357 4.77876 15.4155 4.57879 15.4137 4.37121C15.4119 4.16364 15.3286 3.96508 15.1818 3.8183C15.035 3.67152 14.8365 3.58826 14.6289 3.58646C14.4213 3.58465 14.2214 3.66445 14.0721 3.80866L9.50018 8.38053L4.9283 3.80786V3.80866Z" fill="black" />
                </svg>
              </div>
            </div>
          )
        }
        <div className='w-full' style={{padding:"12px"}}>
          <div className='d-flex space-between'>
            <p className='flex-item fs-16' style={{width:"46%"}}>Membership Name</p>
            <p className='flex-item fs-16 font-weight-600' style={{width:"46%"}}>{membership.membershipplans[0].name}</p>
          </div>        
          <div className='d-flex space-between m-t-14'>
            <p className='flex-item fs-16' style={{width:"46%"}}>Duration</p>
            <p className='flex-item fs-16 font-weight-600' style={{width:"46%"}}>{membership.membershipplans[0].packages[0].duration} {membership.membershipplans[0].packages[0].durationType}'s</p>
          </div>          
          <div className='d-flex space-between m-t-14'>
            <p className='flex-item fs-16' style={{width:"46%"}}>Total Sessions</p>
            <p className='flex-item fs-16 font-weight-600' style={{width:"46%"}}>{membership.sessions}</p>
          </div> 
          <div className='d-flex space-between m-t-14'>
            <p className='flex-item fs-16' style={{width:"46%"}}>Remaining Sessions</p>
            <p className='flex-item fs-16 font-weight-600' style={{width:"46%"}}>{membership.sessions - (membership.completed_sessions?membership.completed_sessions:0)}</p>
          </div>
        </div>

        {/* <div className='w-full d-flex space-between p-l-12 p-r-12 m-t-20'>
          <div id="start-date" onClick={toggleInputFields('start-date')} className={`${currentElementId == "start-date" || startDate ? "member-global-input-field m-b-20 flex-item" : "member-global-input-field m-b-20 flex-item d-flex"}`} style={{ border: currentElementId == "start-date" || startDate ? "1px solid var(--darkBlue)" : "", width:"48%" }}>
            <div className="flex-item d-flex">
              <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == "start-date" || startDate ? "10px" : "14px", color: currentElementId == "start-date" || startDate ? "var(--darkBlue)" : "", transition: "180ms" }}>Start Date *</p>
            </div>
            <input placeholder='DD/MM/YYYY' value={startDate && formatDateTime(startDate)} className={`${currentElementId == "start-date" || startDate ? "active-input-field" : "inactive-input-field"}`} type="text" />
          </div>

          <div className={`${currentElementId == "end-date" || endDate ? "member-global-input-field m-b-20 flex-item" : "member-global-input-field m-b-20 flex-item d-flex"}`} style={{ border: currentElementId == "end-date" || endDate ? "1px solid var(--darkBlue)" : "", backgroundColor:"#e0e0e0", width:"48%" }}>
            <div className="flex-item d-flex">
              <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == "end-date" || endDate ? "10px" : "14px", color: currentElementId == "end-date" || endDate ? "var(--darkBlue)" : "", transition: "180ms" }}>End Date</p>
            </div>
            <input disabled id="end-date" placeholder='DD/MM/YYYY' value={endDate && formatDateTime(endDate)} className={`${currentElementId == "end-date" || endDate ? "active-input-field" : "inactive-input-field"}`} type="text" />
          </div>
        </div> */}
        <div className='w-full p-l-12 p-r-12 m-t-20'>
          <div onClick={toggleInputFields('select-trainer')} className={`${(currentElementId == "select-trainer" || selectedTrainer) ? "member-global-input-field m-b-20 flex-item" : "member-global-input-field m-b-20 flex-item d-flex"}`} style={{ border: (currentElementId == "select-trainer" || selectedTrainer) ? "1px solid var(--darkBlue)" : "" }}>
            <div className="flex-item d-flex">
              <svg className="flex-item m-r-8" width={(currentElementId == "select-trainer" || selectedTrainer) ? "18" : "18"} height={(currentElementId == "select-trainer" || selectedTrainer) ? "18" : "18"} style={{ transition: "180ms" }} viewBox="0 0 15 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.73333 1H3.1C3.00717 1 2.91815 1.03687 2.85251 1.10251C2.78687 1.16815 2.75 1.25717 2.75 1.35V6.48333C2.75 6.5293 2.75905 6.57481 2.77664 6.61727C2.79423 6.65974 2.82001 6.69832 2.85251 6.73082C2.88501 6.76332 2.9236 6.7891 2.96606 6.80669C3.00852 6.82428 3.05404 6.83333 3.1 6.83333H4.73333C4.7793 6.83333 4.82481 6.82428 4.86727 6.80669C4.90974 6.7891 4.94832 6.76332 4.98082 6.73082C5.01332 6.69832 5.0391 6.65974 5.05669 6.61727C5.07428 6.57481 5.08333 6.5293 5.08333 6.48333V1.35C5.08333 1.25717 5.04646 1.16815 4.98082 1.10251C4.91518 1.03687 4.82616 1 4.73333 1V1ZM11.7333 1H10.1C10.0072 1 9.91815 1.03687 9.85251 1.10251C9.78687 1.16815 9.75 1.25717 9.75 1.35V6.48333C9.75 6.5293 9.75905 6.57481 9.77664 6.61727C9.79423 6.65974 9.82001 6.69832 9.85251 6.73082C9.88501 6.76332 9.9236 6.7891 9.96606 6.80669C10.0085 6.82428 10.054 6.83333 10.1 6.83333H11.7333C11.7793 6.83333 11.8248 6.82428 11.8673 6.80669C11.9097 6.7891 11.9483 6.76332 11.9808 6.73082C12.0133 6.69832 12.0391 6.65974 12.0567 6.61727C12.0743 6.57481 12.0833 6.5293 12.0833 6.48333V1.35C12.0833 1.25717 12.0465 1.16815 11.9808 1.10251C11.9152 1.03687 11.8262 1 11.7333 1V1Z" stroke={(currentElementId == "select-trainer" || selectedTrainer) ? "var(--darkBlue)" : "#6d6d6d"} stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M5.08333 3.91675H9.75M1 5.31675V2.51675C1 2.42392 1.03687 2.3349 1.10251 2.26926C1.16815 2.20362 1.25717 2.16675 1.35 2.16675H2.4C2.49283 2.16675 2.58185 2.20362 2.64749 2.26926C2.71313 2.3349 2.75 2.42392 2.75 2.51675V5.31675C2.75 5.40957 2.71313 5.4986 2.64749 5.56424C2.58185 5.62987 2.49283 5.66675 2.4 5.66675H1.35C1.25717 5.66675 1.16815 5.62987 1.10251 5.56424C1.03687 5.4986 1 5.40957 1 5.31675V5.31675ZM13.8333 5.31675V2.51675C13.8333 2.42392 13.7965 2.3349 13.7308 2.26926C13.6652 2.20362 13.5762 2.16675 13.4833 2.16675H12.4333C12.3405 2.16675 12.2515 2.20362 12.1858 2.26926C12.1202 2.3349 12.0833 2.42392 12.0833 2.51675V5.31675C12.0833 5.40957 12.1202 5.4986 12.1858 5.56424C12.2515 5.62987 12.3405 5.66675 12.4333 5.66675H13.4833C13.5762 5.66675 13.6652 5.62987 13.7308 5.56424C13.7965 5.4986 13.8333 5.40957 13.8333 5.31675V5.31675Z" stroke={(currentElementId == "select-trainer" || selectedTrainer) ? "var(--darkBlue)" : "#6d6d6d"} stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "select-trainer" || selectedTrainer) ? "10px" : "14px", color: (currentElementId == "select-trainer" || selectedTrainer) ? "var(--darkBlue)" : "", transition: "180ms" }}>Trainer *</p>
            </div>
            <div className='input-field-arrow-dropdown' style={{ margin: "12px 8px 4px 0", transition: "180ms" }}>
              <svg className="flex-item" style={{ transform: isTrainerListOpen ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
              </svg>
            </div>
            <input id="select-trainer" className={`${(currentElementId == "select-trainer" || selectedTrainer) ? "active-input-field" : "inactive-input-field"}`} type="text" placeholder="Select Gym Type" value={selectedTrainer && selectedTrainer.name} style={{ pointerEvents: "none",textTransform:'capitalize' }} />
            {
              isTrainerListOpen && (
                <div className="global-input-field-arrow-dropdown" style={{maxHeight:"140px", overflowY:"scroll"}}>
                  {
                    trainers.map(data => {
                      return(
                        <div onClick={()=>handleSelectTrainer(data)} className="global-input-field-arrow-dropdown-item">
                          <p className="flex-item">{data.name}</p>
                        </div>
                      )
                    })
                  }
                </div>
              )
            }
          </div>
        </div>

   
       <div className='d-flex space-between m-b-12' style={ window.innerWidth > 767 ? {marginTop:"60px", paddingLeft:"12px", paddingRight:"12px"}  : { marginTop:"auto", paddingTop:"24px", paddingLeft:"12px", paddingRight:"12px", width:"100%", boxSizing:"border-box" } }>
          <div onClick={()=>props.toggleFitnessTestModal("edit-membership")} className={`member-button-global btn-center d-flex`} style={{ width: "48%", height:"44px", borderRadius:"20px" }}>
            <p className="flex-item">Cancel</p>
          </div>
          <div onClick={isButtonLock?null:EditMemberShip} className={`member-button-global  ${isButtonLock ? "member-button-global-inactive" : "global-blue-button-controller-active"} btn-center d-flex`} style={{ width: "48%", height:"44px", borderRadius:"20px",pointerEvents:isButtonLock?'none':'auto' }}>
            <p className="flex-item">Save Changes</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditMembershipModal;